import React, { forwardRef } from 'react';
import Animated from 'react-native-reanimated';
import { Circle, Path, Use } from 'react-native-svg';
import LinearGradient from 'utils/packages/linearGradient';
import { Text, TextInput, SectionList } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { KeyboardAwareScrollView } from 'utils/packages/rnKeyboardAwareScrollview';
export const AnimatedUse = Animated.createAnimatedComponent(Use);
export const AnimatedText = Animated.createAnimatedComponent(Text);
export const AnimatedPath = Animated.createAnimatedComponent(Path);
export const AnimatedCircle = Animated.createAnimatedComponent(Circle);
// Once an animation settles, Reanimated hands its animated `text` back to React
// as a prop (FORCE_REACT_RENDER_FOR_SETTLED_ANIMATIONS), but TextInput ignores
// `text` and sends its defaultValue to native on every render, so the next
// re-render reset the text. Use the settled text as the defaultValue.
const TextInputWithSettledText = forwardRef(({ text, defaultValue, ...props }, ref) => (<TextInput ref={ref} {...props} defaultValue={text ?? defaultValue}/>));
TextInputWithSettledText.displayName = 'TextInputWithSettledText';
export const AnimatedTextInput = Animated.createAnimatedComponent(TextInputWithSettledText);
export const AnimatedTouchableBounce = Animated.createAnimatedComponent(TouchableBounce);
export const AnimatedSectionList = Animated.createAnimatedComponent(SectionList);
export const LinearGradientAnimated = Animated.createAnimatedComponent(LinearGradient);
export const AnimatedKeyboardAwareScrollView = Animated.createAnimatedComponent(KeyboardAwareScrollView);
